import { render, staticRenderFns } from "./EconfModal.vue?vue&type=template&id=2e51edf8&scoped=true"
import script from "./EconfModal.vue?vue&type=script&lang=js"
export * from "./EconfModal.vue?vue&type=script&lang=js"
import style0 from "./EconfModal.vue?vue&type=style&index=0&id=2e51edf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e51edf8",
  null
  
)

export default component.exports